module.exports = __webpack_public_path__ + "img/0Q3A9771_L_BlackMatted.c6c956b4.jpg";